export default function NotFound() {
  return <div>This is 404 Page</div>;
}
